import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { ChapterProgress } from "@/components/ChapterProgress";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { ImpactDashboard } from "@/components/ImpactDashboard";
import { Timeline } from "@/components/Timeline";
import { KnowledgeVault } from "@/components/KnowledgeVault";
import { BeyondBoardroom } from "@/components/BeyondBoardroom";
import { ChapterOne } from "@/components/chapters/ChapterOne";
import { ChapterTwo } from "@/components/chapters/ChapterTwo";
import { ChapterThree } from "@/components/chapters/ChapterThree";
import { ChapterFour } from "@/components/chapters/ChapterFour";
import { ChapterFive } from "@/components/chapters/ChapterFive";
import { ChapterSix } from "@/components/chapters/ChapterSix";
import { ChapterSeven } from "@/components/chapters/ChapterSeven";
import { ChapterEight } from "@/components/chapters/ChapterEight";
import { ChapterNine } from "@/components/chapters/ChapterNine";
import { ChapterTen } from "@/components/chapters/ChapterTen";
import { ChapterEleven } from "@/components/chapters/ChapterEleven";
import { useAmbientSound } from "@/hooks/useAmbientSound";

function App() {
  const [chapter, setChapter] = useState(1);
  const { enabled, toggle } = useAmbientSound();

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setChapter(Number(e.target.dataset.chapter));
        });
      },
      { threshold: 0.3 }
    );
    document.querySelectorAll("[data-chapter]").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F9FA] font-body text-[#0A192F]">
      <div className="noise-layer" aria-hidden />
      <Navbar soundOn={enabled} onToggleSound={toggle} />
      <ChapterProgress current={chapter} />

      <Hero />
      <Marquee />

      <main>
        <ChapterOne />
        <ChapterTwo />
        <ChapterThree />
        <ChapterFour />
        <ChapterFive />
        <ImpactDashboard />
        <ChapterSix />
        <ChapterSeven />
        <ChapterEight />
        <Timeline />
        <ChapterNine />
        <ChapterTen />
        <KnowledgeVault />
        <BeyondBoardroom />
      </main>

      <ChapterEleven />
    </div>
  );
}

export default App;
